<template>
  <CodeboxIntegrationPage v-if="definition?.id === 'codebox'" />
  <GenericIntegrationPage
    v-else-if="definition"
    :definition="definition"
    :status="statusOf(definition.id)"
    :key="definition.id"
  />
</template>

<script setup lang="ts">
import { computed, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { AppRouteNames } from '@tallo/investor/navigation';

import CodeboxIntegrationPage from './codebox-integration-page.vue';
import GenericIntegrationPage from './generic-integration-page.vue';
import { integrations } from './integrations.config';
import { useIntegrationStatus } from './use-integration-status';

const route = useRoute();
const router = useRouter();
const { statusOf } = useIntegrationStatus();

const definition = computed(() =>
  integrations.find((integration) => integration.id === route.params.integrationId && integration.supported),
);

// A hand-typed or stale URL should land somewhere real rather than on an empty page.
watchEffect(() => {
  if (!definition.value) {
    router.replace({ name: AppRouteNames.INVESTOR_INTEGRATIONS });
  }
});
</script>
